import { Button } from '@mui/material'
import React from 'react'
import theme from '../../util/theme'
import { useNavigate } from 'react-router-dom';
import i18next from 'i18next';
const Btn = ({ bg, color, text, path, type = 'button', width= 'fit-content' }) => {
    const navigate = useNavigate()
    let lng = i18next.language
    return (
        <>
            <Button
                type={type}
                onClick={() => navigate(path)}
                size="large"
                sx={{
                    background: bg ? bg : theme.palette.primary.main,
                    color: color ? color : theme.palette.primary.text, textTransform: 'capitalize', px: 4, py: 1, ":hover": {
                        background: theme.palette.secondary.text,
                        color: theme.palette.secondary.main,
                    },
                    borderTopLeftRadius: '20px',
                    borderBottomLeftRadius: '20px',
                    width: width,
                    fontWeight:400
                }} >
                {text || (lng === 'ar' ? 'المزيد': 'More')}
            </Button>
        </>
    )
}

export default Btn